<div class="fx-row cwi-container fx-gap-3">
  <div
    *ngFor="let logger of loggers"
    class="tw-flex tw-flex-col tw-items-center tw-p-3">
    <div
      class="s-25 tw-rounded tw-flex tw-flex-col tw-items-center tw-justify-center tw-shadow tw-cursor-pointer"
      [attr.data-testid]="logger.name"
      [ngClass]="{
        'bg-white': (logger.checked$ | async) === false,
        'bg-accent-100': logger.checked$ | async,
        'bg-grey-100': logger.disabled
      }"
      (click)="!logger.disabled && logger.changeChecked(); interaction.emit()">
      <img
        class="s-15"
        [ngStyle]="logger.disabled ? {'filter': 'grayscale(100%)'} : null"
        [src]="logger.img">
    </div>
    <div class="tw-text-grey-400 tw-mt-3 tw-text-sm tw-font-medium tw-whitespace-nowrap">
      {{ labels[logger.name] }}
    </div>
  </div>
</div>
